














import { Vue, Component, Prop } from 'vue-property-decorator'
import store from 'src/assets/store'
import { select } from 'components/presenter/item/ParentSelect.vue'
import api from 'src/assets/api/gql'
import ItemCreateDuplicate from 'src/graphql/item/ItemCreateDuplicate.gql'
import ItemChildrenList from 'src/graphql/item/ItemChildrenList.gql'
import { Item, ItemType, ItemsConnection } from 'src/graphql/types'

@Component
export default class PresenterLayoutMenuButtonCopy extends Vue {

  get item () {
    return store.state.presenter.item!
  }

  async copy () {
    const parentId = await select(this, {
      title: this.$t('item.edit.copy').toString(),
      item: this.item,
      type: this.item.type === ItemType.Folder || this.item.type === ItemType.Course ? ItemType.Folder : ItemType.Course
    })
    const copy = await this.copyItem(this.item.id, parentId || 0)
    if (copy) {
      this.$router.replace('/presenter/' + copy.id)
    }
  }

  async copyItem(id: number, parentId: number) {
    const { data: { createItemDuplicate } } = await api.mutate({
      query: ItemCreateDuplicate,
      variables: {
        data: { id, parentId }
      }
    })
    if (createItemDuplicate && createItemDuplicate.item) {
      await this.copyItemChildren(this.item.id, createItemDuplicate.item.id)
      return createItemDuplicate.item
    }
  }

  async copyItemChildren (srcParentId: number, dstParentId: number) {
    let cursor: string | null = null
    let done = false
    while (!done) {
      const { data: { itemChildren } }: { data: { itemChildren: ItemsConnection } } = await api.query({
        query: ItemChildrenList,
        variables: {
          id: srcParentId,
          after: cursor
        }
      })
      if (itemChildren) {
        for (const child of itemChildren.nodes) if (child) {
          await this.copyItem(child.id, dstParentId)
        }
        if (itemChildren.pageInfo.hasNextPage) {
          cursor = itemChildren.pageInfo.endCursor
        } else {
          done = true
        }
      } else {
        done = true
      }
    }
  }
}
